import PaperClipOutlinedIcon from '@ant-design/icons/PaperClipOutlined'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

import { ALLOWED_DESCRIPTION } from './TaskAttachments.utils'

export default function DragOverlay({ identifier }) {
  return (
    <Box sx={styles.overlay}>
      <Box sx={styles.border} />
      <Stack spacing={1} sx={styles.card}>
        <PaperClipOutlinedIcon style={{ fontSize: 36 }} />
        <Typography variant="h4">Drop to attach{identifier ? ` to ${identifier}` : ''}</Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {ALLOWED_DESCRIPTION}
        </Typography>
      </Stack>
    </Box>
  )
}

const styles = {
  overlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    backgroundColor: (theme) => `${theme.palette.primary.main}0f`,
    backdropFilter: 'blur(4px)',
  },
  border: {
    position: 'absolute',
    inset: 12,
    border: '2px dashed',
    borderColor: 'primary.main',
    borderRadius: 1.5,
  },
  card: {
    alignItems: 'center',
    px: 5,
    py: 3,
    borderRadius: 2,
    color: 'primary.main',
    backgroundColor: 'background.paper',
    boxShadow: (theme) => theme.customShadows.z2,
    '& .MuiTypography-h4': { color: 'text.primary' },
  },
}
